// todo: Remove Mapping
export enum MappingTypes {
    CLASSIFICATION = 'CLASSIFICATION',
}
